import React, { forwardRef } from 'react'
import { Trash } from './trash'
import { ButtonMotion } from '../components/button-motion'
import { twMerge } from 'tailwind-merge'

export const TrashBackground = forwardRef<
  HTMLButtonElement,
  {
    onClickButton?: () => void
    className?: string
  }
>(function TrashBackground({ onClickButton, className }, ref) {
  return (
    <ButtonMotion onClickButton={onClickButton} ref={ref}>
      <Trash className={twMerge('h-[16px] w-[16px]', className)} />
    </ButtonMotion>
  )
})
